import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRoseyActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g filter="url(#a)">
      <circle
        cx={21}
        cy={21}
        r={16}
        fill="url(#b)"
        transform="rotate(90 21 21)"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M19.145 11.011a2.011 2.011 0 1 1-4.023 0 2.011 2.011 0 0 1 4.023 0m-1.056 0a.955.955 0 1 1-1.91 0 .955.955 0 0 1 1.91 0"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M26.23 10.288c-.16-.544-.93-.544-1.09 0l-.232.795a2.27 2.27 0 0 1-1.542 1.541l-.794.232c-.544.16-.544.93 0 1.09l.794.232a2.27 2.27 0 0 1 1.542 1.541l.232.795c.16.544.93.544 1.09 0l.232-.795a2.27 2.27 0 0 1 1.54-1.541l.795-.233c.544-.159.544-.93 0-1.089l-.794-.232a2.27 2.27 0 0 1-1.541-1.541zM20.684 17.536a1.76 1.76 0 0 1 1.98.025l4.19 2.93.042.03 2.444 1.598a.748.748 0 0 1-.819 1.252l-.916-.598v6.467a1.76 1.76 0 0 1-1.76 1.76h-8.351a.88.88 0 0 1 0-1.76h8.35v-7.306l-4.189-2.93-1.462.967a.88.88 0 0 1-.97-1.468z"
    />
    <path
      fill="#fff"
      d="M14.925 18.932c.219-.748 1.279-.748 1.497 0l.32 1.093a3.12 3.12 0 0 0 2.12 2.119l1.092.32c.748.218.748 1.278 0 1.497l-1.093.32a3.12 3.12 0 0 0-2.119 2.118l-.32 1.093c-.218.748-1.278.748-1.497 0l-.32-1.093a3.12 3.12 0 0 0-2.119-2.119l-1.092-.32c-.748-.218-.748-1.278 0-1.497l1.092-.32a3.12 3.12 0 0 0 2.12-2.118z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={34.678}
        x2={13.276}
        y1={18}
        y2={33.646}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3752B3" />
        <stop offset={0.775} stopColor="#DE5930" />
      </linearGradient>
      <filter
        id="a"
        width={42}
        height={42}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_512_640"
          stdDeviation={2.5}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgRoseyActive;
